import { CityDropdownForTrip, CommonDateRange, CommonInput, CustomPagination, CustomSelect } from 'components';
import BootstrapTable from 'components/BootstrapTable';
import Tab from 'components/common/Tab';
import { constant } from 'constants/constant'
import { utils } from 'helper';
import moment from 'moment';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { StorageServices } from 'utils';
import { AiOutlineEye } from "react-icons/ai";
import { BsChevronDown, BsThreeDotsVertical } from "react-icons/bs";
import { FaRegTrashCan } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import { getServiceList, getServiceVoucherList } from '_services/workShopServices/workShopServices';
import SingleSelectDropdownInfinite from 'components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite';
import { getAllVehicleNumber, venderDropdownApi } from '_services';
import StorageService from 'utils/StorageServices';
import toast from 'react-hot-toast';
import { MakePaymentOfServiceModal, PaymentConfirmModal, PaymentProcessingOffcanvas, PaymentStatusCard } from 'modals';
import { getAllPermissions } from 'utils/permissionHelper';
import { UserContext } from 'context';

const WorkshopServicing = () => {

  const ITEMS_PER_PAGE = 20
  const DEBOUNCE_DELAY = 500;
  const isResetting = useRef(false);
  const isInitialMount = useRef(true);
  const initailFilter = {
    company_id: StorageServices.getCompanyId(),
    firm_id: StorageServices.getFirmId(),
    limit: ITEMS_PER_PAGE,
    offset: 1,
    start_date: "",
    end_date: "",
    vehicle_id: {},
    vendor_id: {},
    status: "",
    search: "",
  }
const {allMenu} = useContext(UserContext)
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [resetKey, setResetKey] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [serviceList, setServiceList] = useState([])
  const [filter, setFilter] = useState(initailFilter)
  const [selectedRange, setSelectedRange] = useState({
    startDate: "",
    endDate: "",
  });
  const [isOpenMakePayment, setIsOpenMakePayment] = useState(false)
  const [isOpenPayNow, setIsOpenPayNow] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [paymentData, setPaymentData] = useState({
    voucher_id: "",
    data: {}
  })

  const [eaesbuzzId, setEaesbuzzId] = useState({
    eb_account_id: "",
    total_amount: 0
  })
  const [isMakeStatusOpen, setIsMakeStatusOpen] = useState(false);
  const hasLinkServicePermission = getAllPermissions("Servicing", allMenu, 'label');

  useEffect(() => {
    getServiceHandle()
  }, [filter])


  useEffect(() => {
    if (isResetting.current) {
      isResetting.current = false;
      return;
    }

    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    const delayTimer = setTimeout(() => {
      setFilter((prev) => ({
        ...prev,
        search: searchInput,
        offset: 1,
      }));
      return () => clearTimeout(delayTimer);
    }, DEBOUNCE_DELAY);

    return () => clearTimeout(delayTimer);
  }, [searchInput]);

  const getServiceHandle = async () => {
    const payload = {
      ...filter,
      vehicle_id: filter?.vehicle_id?._id,
      vendor_id: filter?.vendor_id?.value,
      status: filter?.status
    }

    try {
      const res = await getServiceVoucherList(payload)
      if (res?.responseCode === 200) {
        setServiceList(res?.data?.list)
        setTotalItems(res?.data?.total_record)
      }
    } catch (error) {

    } finally {

    }

  }

  const addServiceFunction = (e) => {
    navigate('/WorkshopServicing/AddService')
    // setShow(true)
  }

  const tabProps = {
    tabList: constant.workshopServiceTabs,
    activeTab: activeTab,
    isActiveButton: hasLinkServicePermission?.canCreate ?true:false,
    rightButton:  addServiceFunction,
    tabButtonName: 'Add Servicing',
    callBackTab: (e) => {
      setActiveTab(e);
    },
  };

  const columns = [
    { header: "Servicing Date", accessor: "service_date" },
    { header: "Vendor", accessor: "vendor_detail" },
    { header: "Vehicle Number", accessor: "vehicle" },
    { header: "Total Amount", accessor: "sub_total" },
    { header: "Due Balance", accessor: "due_amount" },
    { header: "Under Approval Amount", accessor: "approval_amount" },
    { header: "Bill Status", accessor: "service_status" },
    { header: "Action", accessor: "actionButton" },
  ];


  const paymentStatusOptions = [
    { label: "Pending", value: "Pending" },
    { label: "Completed", value: "Completed" },
    { label: "Partially Paid", value: "Partially Paid" },
  ];


  const rowListData = (data) => {
    return data?.map((item, i) => {
      // Calculate balances properly
      const openingBalance = Number(item?.balance) || 0;
      const debitAmount = Number(item?.debitamt) || 0;
      const creditAmount = Number(item?.creditamt) || 0;

      return {
        ...item,
        serial: (
          <React.Fragment>
            <div className="signDropdown">
              <button className="dropbtn11">
                <BsThreeDotsVertical />
              </button>
              <div className="dropdownContent">
                <Link
                  className="_avPointer"
                  style={{ textDecoration: "none" }}
                >
                  <span className="_samAnchor">
                    <span className="viewIcon_avt">
                      <AiOutlineEye />
                    </span>
                    &nbsp; View
                  </span>
                </Link>
                <Link className="_avPointer" style={{ textDecoration: "none" }}>
                  <span className="_samAnchor">
                    <span className="viewIcon_avt">
                      <FiEdit />
                    </span>
                    &nbsp; Edit
                  </span>
                </Link>
                <div className="_avPointer">
                  <span className="_samAnchor">
                    <span className="deleteIcon_avt">
                      <FaRegTrashCan color="red" />
                    </span>
                    Delete
                  </span>
                </div>
              </div>
            </div>
          </React.Fragment>
        ),
        approval_amount: (<React.Fragment>
          {Number(item?.approval_amount || 0).toFixed(2)}

        </React.Fragment>),
        service_date: (
          <React.Fragment>
            {item?.service_date
              ? utils?.formateDateCalander(item?.service_date)
              : "-"}
          </React.Fragment>
        ),
        vendor_detail: (
          <React.Fragment>
            <div className="" onClick={(e) => {
              e.stopPropagation()
              if (item?.vendor_detail?.name != "No Vendor") {
                navigate(
                  `/account/vendors/details/${item?.vendor_detail?._id}?type=${constant.m_type.vendors}&tab=1&search=${item?.vendor_detail?.name}&offset=1&total_record=25&is_list=true`
                );
              }
              // navigate(`/account/vendors/details/${item.vendor_detail?._id}?type=${constant.m_type.vendors}&tab=${1}&search=${item.vendor_detail?.name}&offset=${+1}&total_record=${25}&is_list=${true}`)
            }}


            >
              {item?.vendor_detail
                ? item.vendor_detail?.name
                : "-"}
            </div>
          </React.Fragment>
        ),
        vehicle: (
          <React.Fragment>
            <div className="imgSel_box">
              {item?.vehicle
                ? item.vehicle?.vehicle_no
                : "-"}
            </div>
          </React.Fragment>
        ),
        sub_total: (
          <React.Fragment>
            <div className="imgSel_box">
              {item?.total_amount ? `₹ ${item?.total_amount.toFixed(2)}` : "₹ 0.00"}
            </div>
          </React.Fragment>
        ),
        due_amount: (
          <React.Fragment>
            <div className="imgSel_box">
              {item?.due_amount ? `₹ ${item?.due_amount.toFixed(2)}` : "₹ 0.00"}
            </div>
          </React.Fragment>
        ),

        service_status: (
          <React.Fragment>
            <div className="imgSel_box" style={{ fontSize: "14px", color: "#0FCA5A", fontWeight: 400 }}>
              {item?.payment_status}
            </div>
          </React.Fragment>
        ),
        actionButton: (
          <React.Fragment>
            {item?.payment_status != "Completed" && <button
              className="dropbtn11"
              style={{
                border: "none",
                background: "#F3F6FF",
                color: "#0049D7",
                fontSize: "14px",
                padding: "5px 20px",
                width: "auto",
                borderRadius: "5px"
              }}
              onClick={(e) => {
                e.stopPropagation()
                setIsOpenMakePayment(item)
                navigate(
                  `/accounting/ptransactions/${item._id}` +
                  `?offset=${filter?.offset}&total_record=${totalItems}&type=1` +
                  `&sequence_no=${item?.sequence_no}` +
                  `&status=${item?.payment_status}` +
                  `&invoice=${item?.invoice}` +
                  `&tab=${2}`
                );
              }}
            >
              Add Payment
            </button>}
          </React.Fragment>
        ),
      };
    });
  };

  const handleApply = (newRange) => {
    setSelectedRange(newRange);
    setFilter((prev) => ({
      ...prev,
      start_date: moment(newRange.startDate).format("YYYY-MM-DD"),
      end_date: moment(newRange.endDate).format("YYYY-MM-DD"),
      offset: 1,
    }));
  };

  const handleReset = () => {
    isResetting.current = true;
    setFilter(initailFilter);
    setSearchInput("")
    setSelectedRange({
      startDate: '',
      endDate: '',
    })
  };

  const handlePageChange = (page) => {
    setFilter((prev) => ({ ...prev, offset: page }));
  };

  const fetchVehicle = async (search, page, limit) => {
    const res = await getAllVehicleNumber({
      company_id: StorageServices?.getCompanyId(),
      offset: page,
      limit,
      search,
      vehicle_ownership: [1, 3]
    });
    if (res?.responseCode === 200) {
      const list = res?.data?.vehicle_list?.map((i) => ({
        ...i,
        name: `${i?.vehicle_no}`,
        ownershipStatus: i?.vehicle_ownership,
      }));
      return {
        items: list,
        total: res?.data?.total_record,
      };
    } else {
      return { items: [], total: 0 };
    }
  };

  const fetchVendor = useCallback(async (search, page, limit) => {
    try {
      const response = await venderDropdownApi({
        company_id: StorageService.getCompanyId(),
        offset: page,
        limit,
        search,
      });

      if (response?.responseCode === 200) {
        const vendors = response.data.vendor_list.map(vendor => ({
          ...vendor,
          label: vendor.name,
          value: vendor._id
        }));

        return {
          items: vendors,
          total: response.data.total_record || vendors.length,
        };
      }

      toast.error(response?.responseMessage);
      return { items: [], total: 0 };
    } catch (error) {
      console.error("Error fetching vendors:", error);
      return { items: [], total: 0 };
    }
  }, []);

  const callBackFreight = () => {
    getServiceHandle()
  }

  // const onRowClick = (e, data) => {

  //   e?.stopPropagation();
  //   e?.preventDefault();

  //   navigate(
  //     `/WorkshopServicing/AddService`,
  //     {
  //       state: {
  //         data: data
  //       },
  //     }
  //   )
  // }

  const onRowClick = (e, row) => {
    // Find original item from serviceList
    const originalItem = serviceList.find(item => item._id === row._id);

    console.log("Original item:", originalItem);

    // navigate(`/WorkshopServicing/AddService`, {
    //   state: { data: originalItem, view: true } // ✅ Original data without JSX
    // });
  }

  const paymentResult = (data, voucher_id) => {

    setIsProcessing(false);
    setIsOpenPayNow(false)
    setIsOpenMakePayment(false)
    setIsMakeStatusOpen(true);
    setPaymentData({
      voucher_id: voucher_id,
      data: data
    })

  }

  const callbackEaesbuzz = (id, amount, venderDetails, payload) => {

    setEaesbuzzId((pre) => ({
      ...pre, eb_account_id: id,
      total_amount: amount,
      vendor_bank_account: venderDetails?.vendor_bank_account,
      payload: payload
    }))
  }

  const onShareReceipt = () => {

  }

  const viewReceiptHandle = (data) => {
    setIsSuccessOpen(data)
  }

  const doneHandle = () => {

    setIsOpenPayNow(false)
    setIsMakeStatusOpen(false)
    setIsOpenMakePayment(false)
  }

  const isDisabled =
    !searchInput &&
    !filter?.vehicle_id?._id &&
    !filter?.vendor_id?.value &&
    !filter?.status &&
    !selectedRange?.startDate;

  const makePaymentProps = {
    isOpen: isOpenMakePayment,
    closeModal: () => setIsOpenMakePayment(false),
    headerPart: false,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _lgModal",
    modalTitle: "Make Payment",
    submitTitle: "Save",
    callBackFreight: callBackFreight,
    setIsOpenPayNow,
    callbackEaesbuzz
  }

  let payNowProps = {
    isOpen: isOpenPayNow,
    closeModal: (e) => setIsOpenPayNow(false),
    setIsProcessing, setIsProcessing,
    setIsOpenPayNow: setIsOpenPayNow,
    easebuzzDetails: eaesbuzzId,

  }

  return (
    <>
      <div className='addPr_flBx __wrkShpSrvcng'>

        <Tab {...tabProps} />

        {activeTab === 1 && (
          <>
            <div className='pr_procssBx' id="addPartyContent" style={{ margin: '0px' }}>
              <div className='pr_procssBx_grid'>

                <div>
                  <CommonDateRange
                    key={resetKey}
                    onApply={handleApply}
                    initialStartDate={selectedRange.startDate || ""}
                    initialEndDate={selectedRange.endDate || ""}
                    datePrefield={!!(selectedRange.startDate && selectedRange.endDate)}
                  />
                </div>

                <div style={{ flex: '0 0 220px' }}>

                  <SingleSelectDropdownInfinite
                    label="Vehicle Number"
                    placeholder="Vehicle Number"
                    fetchData={fetchVehicle}
                    selectedItem={filter?.vehicle_id}
                    onChange={(data) => setFilter((pre) => ({ ...pre, vehicle_id: data }))}
                    loadOnOpen={true}
                    vehicleStatus={false}
                  />
                </div>

                <div style={{ flex: '0 0 220px' }}>
                  <CityDropdownForTrip
                    label="Vendor"
                    placeholder="Select Vendor"
                    fetchData={fetchVendor}
                    pageSize={20}
                    onChange={(data) => setFilter((pre) => ({ ...pre, vendor_id: data }))}
                    selectedItem={filter.vendor_id ? filter?.vendor_id : null}

                  />
                </div>

                <div style={{ flex: '0 0 220px' }}>
                  <CustomSelect
                    options={paymentStatusOptions}
                    name="bill_status"
                    flotingLabel="Bill Status"
                    placeholder="Bill Status"
                    onSelect={(data) => setFilter((pre) => ({ ...pre, status: data?.value }))}
                    value={filter?.status ? paymentStatusOptions?.find((i) => i?.value == filter?.status) : { label: "", value: "" }}
                  />
                </div>

                <div style={{ flex: '0 0 220px' }}>
                  <CommonInput
                    placeholder="Search "
                    label="Search "
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                  />
                </div>
                <button
                  className="anime-btn __reSet_btn"
                  disabled={isDisabled}
                  onClick={handleReset}
                  style={{
                    backgroundColor: isDisabled ? "#ccc" : "#1956f6",
                    color: isDisabled ? "#666" : "white",
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "6px",
                    transition: "all 0.3s ease",
                  }}
                >
                  Reset
                </button>

              </div>
            </div>

            {/* Table Section */}
            <div className="_tabWith_outTab">
              <BootstrapTable
                tableClass="companyTable_bx"
                columns={columns}
                data={rowListData(serviceList?.length > 0 ? serviceList : [])}
                onRowClick={onRowClick}
              />
              <div className="paginationFt_avt">
                <CustomPagination
                  totalItems={totalItems || 1}
                  itemsPerPage={ITEMS_PER_PAGE}
                  currentPage={filter.offset}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </>
        )}

        {activeTab === 2 && (
          <>2</>
        )}

        {activeTab === 3 && (
          <>3</>
        )}

        {isOpenMakePayment && <MakePaymentOfServiceModal {...makePaymentProps} />}
        {isOpenPayNow && <PaymentConfirmModal {...payNowProps} />}
        {isProcessing && <PaymentProcessingOffcanvas
          isOpen={isProcessing}
          message="Please wait while we process your transaction..."
          paymentResult={paymentResult}
          eaesbuzzId={eaesbuzzId}
          onClose={() => {
            setIsProcessing(false)
            setIsOpenPayNow(false)
            setIsOpenMakePayment(false)
          }}
        />}

        {isMakeStatusOpen && <PaymentStatusCard isOpen={isMakeStatusOpen}
          onClose={() => setIsMakeStatusOpen(false)}
          paymentData={paymentData}
          details={{ _id: paymentData?.data?.voucher_id }}
          onShareReceipt={onShareReceipt}
          viewReceiptHandle={viewReceiptHandle}
          doneHandle={doneHandle}
        />}
      </div>
    </>
  )
}

export default WorkshopServicing